import { render, staticRenderFns } from "./changepassword.vue?vue&type=template&id=1f148b96&"
import script from "./changepassword.vue?vue&type=script&lang=js&"
export * from "./changepassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports